import Component from '@glimmer/component';

interface File {
  title: string;
  date: string;
  fileType: 'PDF' | 'XLS' | 'DOCX';
  reportType: 'VERIFIED' | 'AUTO_GENERATED';
  description?: string;
}

export interface ScansFilesTableSignature {
  Args: {
    files: File[];
  };
  Blocks: {
    default: [];
  };
  Element: HTMLTableElement;
}

export default class ScansFilesTable extends Component<ScansFilesTableSignature> {
  getFilePillStyle(fileType: 'PDF' | 'XLS' | 'DOCX') {
    if (fileType === 'PDF') return 'bg-red-500 border-red-500';
    if (fileType === 'DOCX') return 'bg-blue-500 border-blue-500';
    if (fileType === 'XLS') return 'bg-green-500 border-green-500';
    return '';
  }
}
